module.exports = __webpack_public_path__ + "static/media/2025_Greenland_Travel.e2d9bb0a.pdf";